import { withCompController } from '@wix/editor-elements-integrations';
import type {
  TextParticlesMapperProps,
  TextParticlesStateValues,
  TextParticlesControllerProps,
} from '../TextParticles.types';

export default withCompController<
  TextParticlesMapperProps,
  TextParticlesControllerProps,
  never,
  TextParticlesStateValues
>(({ stateValues, mapperProps }) => {
  const { currentUrlWithQueryParams } = stateValues;
  const urlParams = new URLSearchParams(currentUrlWithQueryParams);
  const isPresetPreview = urlParams.get('dsOrigin') === 'preset_preview';

  return {
    ...mapperProps,
    reducedMotion: stateValues.reducedMotion,
    isPresetPreview,
  };
});
